export default {
  data() {
    return {
      history: [
        { id: 1, date: '15 Dec 2024', reference: 'DIST-2024-Q4', status: 'Completed', amount: 16250 },
        { id: 2, date: '15 Sep 2024', reference: 'DIST-2024-Q3', status: 'Completed', amount: 15100 },
        { id: 3, date: '15 Jun 2024', reference: 'DIST-2024-Q2', status: 'Completed', amount: 14200 },
        { id: 4, date: '15 Mar 2024', reference: 'DIST-2024-Q1', status: 'Missed', amount: 0 },
        { id: 5, date: '15 Dec 2023', reference: 'DIST-2023-Q4', status: 'Completed', amount: 12800 },
      ]
    };
  },
  methods: {
    formatAmount(val) {
      return val.toLocaleString().replace(/,/g, ' ');
    },
    statusBadgeClass(status) {
      if (status === 'Completed') {
        return 'bg-success-subtle text-success border-success';
      }
      if (status === 'Missed') {
        return 'bg-danger-subtle text-danger border-danger';
      }
      return 'bg-light text-dark';
    }
  }
};